import { render } from "./ShowLibros.vue?vue&type=template&id=f6891222&scoped=true"
import script from "./ShowLibros.vue?vue&type=script&lang=js"
export * from "./ShowLibros.vue?vue&type=script&lang=js"

import "./ShowLibros.vue?vue&type=style&index=0&id=f6891222&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f6891222"

export default script